import type { SupabaseClient } from "@supabase/supabase-js";

/** Apply the current Supabase session JWT to the Realtime client (required for private channels). */
export async function applySupabaseRealtimeAuth(supabase: SupabaseClient): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token ?? null;
  if (token) {
    supabase.realtime.setAuth(token);
  }
  return token;
}

type AuthChangeCallback = () => void;

const authCallbacks = new Set<AuthChangeCallback>();
let wiredClient: SupabaseClient | null = null;

/**
 * Keeps the Realtime client authenticated for private channels.
 * Required since supabase-js 2.34.3.
 */
export function wireSupabaseRealtimeAuth(supabase: SupabaseClient, onAuthChange?: AuthChangeCallback) {
  if (onAuthChange) {
    authCallbacks.add(onAuthChange);
  }

  void applySupabaseRealtimeAuth(supabase);

  if (wiredClient === supabase) {
    return;
  }
  wiredClient = supabase;

  supabase.auth.onAuthStateChange((_event, session) => {
    if (session?.access_token) {
      supabase.realtime.setAuth(session.access_token);
    }
    for (const callback of authCallbacks) {
      callback();
    }
  });
}

/** @internal Test helper */
export function resetSupabaseRealtimeAuthForTests() {
  authCallbacks.clear();
  wiredClient = null;
}
